import * as React from "react";
import { IconProps } from "./IconProps";

export const IconSliders = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83333 2.72461C6.29357 2.72461 6.66667 3.09771 6.66667 3.55794V4.49621C8.10465 4.86608 9.16667 6.17089 9.16667 7.72461C9.16667 9.27833 8.10465 10.5831 6.66667 10.953V16.8913C6.66667 17.3515 6.29357 17.7246 5.83333 17.7246C5.3731 17.7246 5 17.3515 5 16.8913V10.953C3.56202 10.5831 2.5 9.27833 2.5 7.72461C2.5 6.17089 3.56202 4.86608 5 4.49621V3.55794C5 3.09771 5.3731 2.72461 5.83333 2.72461ZM14.1667 2.72461C14.6269 2.72461 15 3.09771 15 3.55794V11.1629C16.438 11.5327 17.5 12.8376 17.5 14.3913C17.5 16.2328 16.0082 17.7246 14.1667 17.7246C12.3252 17.7246 10.8333 16.2328 10.8333 14.3913C10.8333 12.8376 11.8953 11.5327 13.3333 11.1629V3.55794C13.3333 3.09771 13.7064 2.72461 14.1667 2.72461ZM5.83333 6.05794C4.91232 6.05794 4.16667 6.8036 4.16667 7.72461C4.16667 8.64562 4.91232 9.39128 5.83333 9.39128C6.75435 9.39128 7.5 8.64562 7.5 7.72461C7.5 6.8036 6.75435 6.05794 5.83333 6.05794ZM14.1667 12.7246C13.2457 12.7246 12.5 13.4703 12.5 14.3913C12.5 15.3123 13.2457 16.0579 14.1667 16.0579C15.0877 16.0579 15.8333 15.3123 15.8333 14.3913C15.8333 13.4703 15.0877 12.7246 14.1667 12.7246Z"
          fill={color}
        />
      </svg>
    );
  },
);
